module.exports = __webpack_public_path__ + "img/3.a5d94e28.png";